export const LABEL = 'Shuffle the questions';
export const MESSAGE = "This will randomize the question's order and remove the number labels.";
